/* Who is playing: a guest until they sign in. Filled in by net/auth.ts once the backend answers. */
import { create } from 'zustand'
import type { Look } from '../ui/Avatar'

export interface Me {
  id: string
  username: string
  displayName: string
  avatar: string | null
  icon: string | null
  color: string
  bio: string
  xp: number
  coins: number
  premiumUntil: string | null
  premium: boolean
  isAdmin: boolean
  streak: number
  streakLast: string | null
  bestStreak: number
  shields: number
  createdAt: string
  equipped: { name_color?: string | null; name_font?: string | null; name_fx?: string | null; banner?: string | null; confetti?: string | null; line?: string | null }
  badges: string[]
  gamesPlayed: number
  roundsPlayed: number
  totalPoints: number
  perfectRounds: number
  bestGame: number
  email: string | null
  birthYear: number | null
  birthMonth: number | null
  tokens: Record<string, number | string>
  giftDay: string | null
  counters: Record<string, unknown>
  today: string
  referredBy: string | null
  referrals: number
  subscription: { status: string; plan: string; current_period_end: string | null; cancel_at_period_end: boolean } | null
}

export interface Session {
  loaded: boolean
  me: Me | null
  look: Look
  adminOn: boolean
}

export const GUEST_LOOK: Look = { name: 'You', color: '#7650e0', icon: 'a-pin', tier: 'none' }

export const useMe = create<Session>(() => ({ loaded: false, me: null, look: GUEST_LOOK, adminOn: true }))

export function lookOf(me: Me | null): Look {
  if (!me) return GUEST_LOOK
  return { name: me.displayName || me.username, username: me.username, avatar: me.avatar, icon: me.icon, color: me.color, xp: me.xp }
}

/* Age from birth month and year, for the one place it matters: only adults pay. */
export function ageOf(me: Me | null) {
  if (!me?.birthYear) return 0
  const d = new Date()
  return d.getFullYear() - me.birthYear - (d.getMonth() + 1 < (me.birthMonth || 1) ? 1 : 0)
}
export const isPremium = (me: Me | null) => !!me && !!me.premiumUntil && new Date(me.premiumUntil).getTime() > Date.now()
/* The streak still counts if you played today or yesterday (New York days). */
export function liveStreak(me: Me | null) {
  if (!me || !me.streakLast) return 0
  const t = new Date(me.today + 'T12:00:00Z').getTime(), l = new Date(me.streakLast + 'T12:00:00Z').getTime()
  return t - l <= 86400e3 + 1000 ? me.streak : 0
}
